import { VacancySpendStatus } from '../types/vacancyTypes';

/**
 * What the Start/Stop Campaign button does (SYM-6583).
 * - toggle: the usual start or stop confirmation.
 * - add-budget: the budget is used up and the campaign is stopped, so starting it means adding
 *   budget first. The budget window does that, and the server restarts the campaign once the
 *   budget is paid.
 * - blocked: the budget is used up while the campaign still counts as running.
 */
export type CampaignButtonAction = 'toggle' | 'add-budget' | 'blocked';

export const campaignButtonAction = (
  budgetSpent: boolean,
  campaignStatus: VacancySpendStatus
): CampaignButtonAction => {
  if (!budgetSpent) return 'toggle';

  return campaignStatus === VacancySpendStatus.ACTIVE
    ? 'blocked'
    : 'add-budget';
};
